import React, { Component, Fragment } from "react";
import { injectIntl } from "react-intl";
import _ from "lodash-uuid";

import { FormControl, InputLabel, Select, MenuItem, IconButton } from "@material-ui/core";
import { withTheme, withStyles } from "@material-ui/core/styles";

import ClearIcon from "@material-ui/icons/Clear";
import FormattedMessage from "../generics/FormattedMessage";
import TextInput from "./TextInput";

const styles = (theme) => ({
  label: {
    color: theme.palette.primary.main,
  },
  formControl: {
    position: "relative",
  },
  iconButton: {
    position: "absolute",
    right: 0,
    padding: "8px",
  },
});

function EmptyComponent() {
  return <div />;
}

class SelectInput extends Component {
  _onChange = (e) => {
    if (this.props.value !== e.target.value) {
      this.props.onChange(JSON.parse(e.target.value));
    }
  };

  handleClear = () => {
    this.props.onChange("");
  };

  // When there is a value, we pass a dummy div to effectively hide the default dropdown icon.
  // This allows us to make room for the clear icon without having two icons visible at the same time.
  renderIconComponent = () => {
    const { value } = this.props;
    return value ? EmptyComponent : undefined;
  };

  // If there's a value, we render the clear icon. Clicking it calls handleClear, which resets the Select's value.
  renderEndAdornment = () => {
    const { value, classes } = this.props;
    return value ? (
      <IconButton onClick={this.handleClear} className={classes.iconButton}>
        <ClearIcon />
      </IconButton>
    ) : undefined;
  };

  render() {
    const {
      classes,
      module,
      label,
      strLabel = null,
      withLabel = true,
      name,
      options,
      value,
      disabled = false,
      readOnly = false,
      required = false,
      placeholder,
      title = '',
    } = this.props;
    if (!options) return null;
    let valueStr = null;
    if (!!readOnly) {
      valueStr = options.filter((o) => JSON.stringify(o.value) === JSON.stringify(value)).map((o) => o.label);
    }
    return (
      <Fragment>
        {!readOnly && (
          <FormControl required={required} fullWidth className={classes.formControl}>
            <InputLabel shrink={true} className={classes.label}>
              {strLabel ?? <FormattedMessage module={module} id={label} />}
            </InputLabel>
            <Select
              readOnly={readOnly}
              inputProps={{
                name: name,
                id: `${_.uuid()}-input`,
                title: title,
              }}
              value={!!value ? JSON.stringify(value) : null}
              onChange={this._onChange}
              IconComponent={this.renderIconComponent()}
              disabled={disabled}
              endAdornment={this.renderEndAdornment()}
              displayEmpty
              //NOTE: We want to get rid of default styling (marginTop) if label is not rendered
              {...(withLabel ? null : { style: { marginTop: "0px" } })}
            >
              {placeholder && (
                <MenuItem disabled value="">
                  <FormattedMessage module={module} id={placeholder} />
                </MenuItem>
              )}
              {options.map((option, idx) => (
                <MenuItem key={`${module}-${name}-option-${idx}`} value={JSON.stringify(option.value)}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {!!readOnly && (
          <TextInput
            //NOTE: We want to get rid of default styling (marginTop) if label is not rendered
            {...(withLabel ? { label } : null)}
            fullWidth={true}
            module={module}
            value={valueStr}
            readOnly={true}
            title={title}
          />
        )}
      </Fragment>
    );
  }
}

export default injectIntl(withTheme(withStyles(styles)(SelectInput)));
